/** L'étape mesurée : le nom de son champ, ou ceux de ses champs (`form.step.*`, propriété `step`, P-4823). */
export const formStepName = (step) =>
    step?.name ?? step?.inputs?.map((x) => x?.name).join(",") ?? "unknown"
